/**
 * What can have to be ready before part of a plan starts. A plan's `starts[].needs` names these ids; Get
 * ready checks each one from real state (a connection's checks, an approval), never from a tick box.
 * The list is open: a new kind of connection or approval adds an entry here and plans can use it.
 */
export interface ReadinessDef {
  label: string;
  /** How Flashadz knows it is ready. */
  check: { kind: "connection"; connection: string; checks?: string[] } | { kind: "approval"; of: string };
}

export const READINESS: Record<string, ReadinessDef> = {
  meta_account: { label: "Meta ad account connected", check: { kind: "connection", connection: "meta" } },
  meta_pixel: { label: "Meta receives results", check: { kind: "connection", connection: "meta", checks: ["pixel"] } },
  email_mailbox: { label: "Cold email provider and sending address", check: { kind: "connection", connection: "email" } },
  email_warmup: { label: "Sending addresses ready", check: { kind: "connection", connection: "email", checks: ["mailbox_ready"] } },
  email_copy_approval: { label: "First emails approved", check: { kind: "approval", of: "emails" } },
  ad_creative_approval: { label: "Ads approved", check: { kind: "approval", of: "ads" } },
  linkedin_account: { label: "LinkedIn ad account connected", check: { kind: "connection", connection: "linkedin" } },
};

export const readinessList = () => Object.entries(READINESS).map(([id, d]) => ({ id, label: d.label }));
